import type { PreviewSeed } from "@contracts/types";

export const permanentSample: PreviewSeed = {
  username: "Anggun",
  location: "Indonesia",
  caption: `Matahari terbenam di balik awan,
Meninggalkan jingga di ujung kelam.
Uang mati di genggaman,
Manfaat hidup abadi tertanam.`,
  likes: "999",
  ratio: "4 / 5",
  avatarUrl: "/sample/01-4x5.png",
  slides: [
    {
      kind: "image",
      url: "/sample/01-4x5.png",
      name: "Rice terraces · 4:5",
      sourceRatio: "4 / 5",
    },
    {
      kind: "image",
      url: "/sample/02-3x4.png",
      name: "Balinese architecture · 3:4",
      sourceRatio: "3 / 4",
    },
    {
      kind: "image",
      url: "/sample/03-landscape.png",
      name: "Indonesian coast · 1.91:1",
      sourceRatio: "1.91 / 1",
    },
    {
      kind: "image",
      url: "/sample/04-1x1.png",
      name: "Bromo highlands · 1:1",
      sourceRatio: "1 / 1",
    },
    {
      kind: "image",
      url: "/sample/05-9x16.png",
      name: "Pine forest · 9:16",
      sourceRatio: "9 / 16",
    },
  ],
};
